export default "__VITE_ASSET__CMIKZCA6__"